import { render, staticRenderFns } from "./detailContent.vue?vue&type=template&id=97109834&"
import script from "./detailContent.vue?vue&type=script&lang=js&"
export * from "./detailContent.vue?vue&type=script&lang=js&"
import style0 from "./detailContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97109834')) {
      api.createRecord('97109834', component.options)
    } else {
      api.reload('97109834', component.options)
    }
    module.hot.accept("./detailContent.vue?vue&type=template&id=97109834&", function () {
      api.rerender('97109834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/model/agreeDetail/detailContent.vue"
export default component.exports